export const WebsiteCategories = Object.freeze({
  men: 'men',
  women: 'women'
})

export const WebsiteCategoryCookie = 'ota-top-cat'

export const isDevelopment: boolean = (process.env.API_URL !== 'https://onthatass.com/api') || (process.env.NODE_ENV !== 'production')

const StorageKeyPrefix = 'ota-v1-'

export const PersistentStorageKeys = Object.freeze({
  general: `${StorageKeyPrefix}general`,
  menSignup: `${StorageKeyPrefix}signup`,
  webshop: `${StorageKeyPrefix}webshop`
})
